import checkmarkIcon from '/assets/checkmark-big-circle.svg';
import useSettings from '@/hooks/useSettings';

const pixAutoAdvantage = [
  { icon: checkmarkIcon, message: 'Liberação imediata' },
  { icon: checkmarkIcon, message: 'Assinatura sempre em dia' },
  {
    icon: checkmarkIcon,
    message: 'Com o Pix Automático, as renovações são feitas de forma recorrente, sem preocupação'
  },
  {
    icon: checkmarkIcon,
    message:
      'Autorize uma vez o pagamento no app do seu banco e os próximos a gente cuida para você'
  }
];

export function PixAutoForm() {
  const settings = useSettings();

  return (
    <>
      <div
        style={{
          borderWidth: '2.3px'
        }}
        className="rounded-md border border-[#0F7864] border-dashed p-3"
      >
        <ul>
          {pixAutoAdvantage.map(({ icon, message }) => (
            <li key={message} className="flex items-center py-1 px-3 xs:px-1">
              <img src={icon} alt="Checkmark Icon" style={{ height: '18px', width: '18px' }} />
              <p
                style={{ color: settings.text.color.primary }}
                className="text-[13px] text-white text-bold ml-2"
              >
                {message}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
